export const SOFTWARE_REQUEST_FILE_MAX_BYTES = 12288;

/** The .key contains only the already-signed public NEXTREQ1 request, never a private key. */
export function readSoftwareRequestFile(file: File): Promise<string> {
  if (!file.name.toLowerCase().endsWith('.key')) return Promise.reject(new Error('Seleziona il file .key generato dal programma.'));
  if (!file.size || file.size > SOFTWARE_REQUEST_FILE_MAX_BYTES) return Promise.reject(new Error('Il file .key è vuoto o supera 12 KB.'));
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Impossibile leggere il file .key.'));
    reader.onload = () => {
      const text = String(reader.result || '').replace(/^\uFEFF/, '').trim();
      const compact = text.replace(/\s/g, '');
      if (text.length > 12000 || !/^NEXTREQ1\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(compact)) {
        reject(new Error('Il file deve contenere la richiesta NEXTREQ1 generata dal programma, senza chiavi private.'));
      } else resolve(text);
    };
    reader.readAsText(file, 'UTF-8');
  });
}
